import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 79183 79183"
    {...props}
  >
    <path
      d="M2712 2712h52066c11931 0 21693 9762 21693 21694v52065H24406c-11932 0-21694-9762-21694-21693V2712z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 5423.49,
      }}
      className="stroke1"
    />
    <path
      d="M28745 28745h15313c3510 0 6380 2870 6380 6380v15313H35125c-3510 0-6380-2870-6380-6380V28745z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
